Model = require('./Model').default
Collection = require './collection'

module.exports = class RecordBrowserState extends Model
    defaults:
        isGlobal: false
        # previously anonymous attributes
        keywords: null
        searchResults: null
        closeOnSelect: null

    initialize: =>
        @on("change:stereotype", =>
            @set('keywords', "")
            @set('searchResults', undefined)
            @versions = new Collection()
            @get('stereotype').get('creatables').each (creatable)=>
                creatable.get('versions').each (version)=>
                    @versions.add(label: creatable.get('label') + " " + version.get("label"), version: version, lookup: @lookup)
        )



// WEBPACK FOOTER //
// ./app/models/RecordBrowserState.coffee